import axios from 'axios';
import { VITE_FORGE_URL } from '../constants';

const forge = axios.create({
	baseURL: VITE_FORGE_URL,
	withCredentials: true,
});

export default forge;
